module.exports = "https://static.wagwalking.com/_next/static/images/pet-6-4e4837e114dd50599eee25fb33171ff0.png";